import { useEffect } from "react";

/* Small UI pieces shared by the converted pages. */

export function Notice({ notice, onClose }) {
  if (!notice) return null;
  const tone = notice.tone === "ok" ? "ok" : notice.tone === "warn" ? "warn" : "err";
  return (
    <div className={`ui-notice ${tone}`} role={tone === "err" ? "alert" : "status"}>
      <span>{notice.text}</span>
      {onClose && <button type="button" aria-label="Dismiss" onClick={onClose}><i className="fas fa-xmark" /></button>}
    </div>
  );
}

export function Stat({ icon, tone = "brand", label, value, unit }) {
  return (
    <div className="ui-stat">
      <span className={`ui-stat-ic ${tone}`}><i className={`fas ${icon}`} /></span>
      <div>
        <div className="ui-stat-label">{label}</div>
        <div className="ui-stat-value mono">{value}{unit && <span className="unit">{unit}</span>}</div>
      </div>
    </div>
  );
}

/** Modal dialog; closes on Escape or backdrop click. */
export function Modal({ title, children, onClose, actions }) {
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, [onClose]);
  return (
    <div className="ui-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="ui-modal" role="dialog" aria-modal="true" aria-label={title}>
        <h2>{title}</h2>
        <div className="ui-modal-body">{children}</div>
        <div className="ui-modal-actions">{actions}</div>
      </div>
    </div>
  );
}

export function Pager({ page, totalPages, onPage }) {
  if (totalPages <= 1) return null;
  return (
    <div className="ui-pager">
      <span>Page {page} of {totalPages}</span>
      <button type="button" className="btn" disabled={page <= 1} onClick={() => onPage(page - 1)}>Previous</button>
      <button type="button" className="btn" disabled={page >= totalPages} onClick={() => onPage(page + 1)}>Next</button>
    </div>
  );
}

/** Amount input that shows thousands separators while typing (like the PHP pages' formatAmount). */
export function MoneyInput({ value, onChange, ...rest }) {
  const format = (raw) => {
    const clean = String(raw).replace(/,/g, "").replace(/[^\d.]/g, "");
    if (!clean) return "";
    const [int, ...dec] = clean.split(".");
    const intFmt = int ? Number(int).toLocaleString("en-US") : "0";
    return dec.length ? `${intFmt}.${dec.join("").slice(0, 2)}` : intFmt;
  };
  return <input type="text" inputMode="decimal" value={value} onChange={(e) => onChange(format(e.target.value))} {...rest} />;
}

/** "1,234.50" -> 1234.5 */
export const parseMoney = (s) => parseFloat(String(s || "").replace(/,/g, "")) || 0;
